import { Container, Grid } from '@mui/material'
import React from 'react'
import { P, SectionHeading, SectionSubHeading, SectionWrapper } from '../../Styles/style'

import launch from "../../../assets/images/launch.png"
import dev from "../../../assets/images/dev.png"
import innove from "../../../assets/images/innove.png"
import styled from '@emotion/styled'

const AboutImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 80%; */
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
/* padding: 50px 0; */
align-items: center;
place-content: ${(props) => (props.pc ? props.pc : "")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
`;
const JOiningLinks = styled.img`
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")};
  @media screen and (max-width:599px){
   max-width: ${(props) => (props.mw ? props.mw : "140PX")};

 } */
`
const FeatureWrapper = styled.div`

height: 327px;
 background: 
    linear-gradient(#000000 0 0) padding-box, /*this is your grey background*/
    linear-gradient(319deg, #000,#000,#000, #1765FF) border-box;
  border: 1px solid transparent;
backdrop-filter: blur(13px) !important;
  padding: 20px;
`
const S7_Roadmap = () => {
    return (
        <div>
            <SectionWrapper p="4rem 0" id="roadmap">
                <Container maxWidth="xl">
                    <SectionHeading data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="400"
                        data-aos-duration="500"
                        data-aos-offset="0">
                        Roadmap
                    </SectionHeading>
                    <GridHEading container spacing={3}>

                        <GridImage item xs={12} md={6} lg={4} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="400"
                            data-aos-duration="500">
                            <FeatureWrapper>

                                <SectionSubHeading fs="18px"> <JOiningLinks src={launch} />&nbsp;&nbsp;Project
                                <br/>  &nbsp;  Launch</SectionSubHeading>
                                <P
                                    maxWidth="90%"
                                    p="0 0 40px 0"
                                    m="0"
                                    data-aos="fade-zoom-in"
                                    data-aos-easing="ease-in"
                                    data-aos-delay="600"
                                    data-aos-duration="600"
                                    data-aos-offset="0"
                                >
                                    - Project Socials
                                    <br />
                                    <br />
                                    - Website Launch
                                    <br />
                                    <br />

                                    - Token Launch

                                </P>
                            </FeatureWrapper>


                        </GridImage>
                        <GridImage item xs={12} md={6} lg={4} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                            <FeatureWrapper>

                                <SectionSubHeading fs="18px"> <JOiningLinks src={dev} />&nbsp;&nbsp;Future
                                <br/>&nbsp;  Developments</SectionSubHeading>
                                <P
                                    maxWidth="90%"
                                    p="0 0 40px 0"
                                    m="0"
                                    data-aos="fade-zoom-in"
                                    data-aos-easing="ease-in"
                                    data-aos-delay="600"
                                    data-aos-duration="600"
                                    data-aos-offset="0"
                                >
                                    -Development of a mobile app for easy access to the platform
                                    <br />
                                    <br />
                                    -Launch of a staking program to provide additional benefits for our holders
                                </P> </FeatureWrapper>


                        </GridImage>
                        <GridImage item xs={12}md={6} lg={4} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="600"
                            data-aos-duration="500">
                            <FeatureWrapper>

                                <SectionSubHeading fs="18px"> <JOiningLinks src={innove} /> &nbsp;&nbsp;Innovation
                                 <br/>&nbsp;   And Build Ecosystem</SectionSubHeading>
                                <P
                                    maxWidth="90%"
                                    p="0 0 40px 0"
                                    m="0"
                                    data-aos="fade-zoom-in"
                                    data-aos-easing="ease-in"
                                    data-aos-delay="600"
                                    data-aos-duration="600"
                                    data-aos-offset="0"
                                >
                                    -Establish partnerships with other DeFi protocols to increase the utility of our token
                                    <br />
                                    <br />
                                    -Build a bridge to enable seamless transfers between different networks.</P> </FeatureWrapper>


                        </GridImage>

                    </GridHEading>
                </Container>

            </SectionWrapper>
        </div>
    )
}

export default S7_Roadmap